export const age = [
    {
        id: 0,
        name: 'under 20 years old',
        age: 11,
        ago: 0,
    },
    {
        id: 1,
        name: '21 to 30 years old',
        age: 21,
        ago: 5,
    },
    {
        id: 2,
        name: '31 to 40 years old',
        age: 31,
        ago: 15,
    },
    {
        id: 3,
        name: '41 to 50 years old',
        age: 41,
        ago: 25,
    },
    {
        id: 4,
        name: '51 to 60 years old',
        age: 51,
        ago: 35,
    },
    {
        id: 5,
        name: 'over 60 years old',
        age: 61,
        ago: 45,
    },
];